import { render, staticRenderFns } from "./AddDocumentModal.vue?vue&type=template&id=64c4f91e&scoped=true"
import script from "./AddDocumentModal.vue?vue&type=script&lang=ts"
export * from "./AddDocumentModal.vue?vue&type=script&lang=ts"
import style0 from "./AddDocumentModal.vue?vue&type=style&index=0&id=64c4f91e&prod&lang=css"
import style1 from "./AddDocumentModal.vue?vue&type=style&index=1&id=64c4f91e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c4f91e",
  null
  
)

export default component.exports